import { toAbsoluteUrl } from "src/_metronic/helpers/AssetHelpers";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";

import SVG from "react-inlinesvg";

export default function offSiteGridHistoryColumns(
    formatMessage: any
): Array<SimpleEntityGridColumn> {
    return [
        {
            field: "id",
            filter: "agSetColumnFilter",
            cellClass: "number-cell",
            minWidth: 60,
            maxWidth: 60,
            hide: true,
        },
        {
            field: "source",
            headerName: formatMessage({ id: "content.grid.col.contentType" }),
            valueGetter: ({ data }: any) =>
                `${formatMessage({
                    id: `content.grid.col.contentType.${data.source}`,
                })}`,
            minWidth: 100,
            maxWidth: 100,
        },
        {
            field: "service",
            headerName: formatMessage({ id: "apiCredential.grid.col.service" }),
            maxWidth: 250,
            checkboxSelection: false,
        },
        {
            field: "data",
            headerName: formatMessage({ id: "content.grid.col.data" }),
            valueGetter: ({ data }: any) => {
                if (!data.deliveredAt) return `${formatMessage({ id: "write.title" })}`;
                if (!data.reviewedAt && data.reviewNeeded)
                    return `${formatMessage({ id: "proofread.title" })}`;
                if (data.approveNeeded && !data.isApproved)
                    return `${formatMessage({ id: "approve.title" })}`;
                if (!data.url) return `${formatMessage({ id: "publish.title" })}`;
            },
        },
        {
            field: "status",
            minWidth: 80,
            maxWidth: 80,
            headerName: formatMessage({ id: "content.grid.col.status" }),
            filter: "agSetColumnFilter",
            valueGetter: ({ data }: any) => {
                return data?.status;
            },
            cellRenderer: (params: { data: any }) => {
                const { data } = params;
                if (data?.status === 0) {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen034.svg")}
                            className="svg-icon-danger"
                        />
                    );
                }
                if (data?.status === 1) {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen037.svg")}
                            className="svg-icon-valid"
                        />
                    );
                }
                if (data?.status === 2) {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen046.svg")}
                            className="svg-icon-warning"
                        />
                    );
                }
                if (data?.status === 3) {
                    return (
                        <SVG
                            src={toAbsoluteUrl("/media/icons/duotune/general/gen046.svg")}
                            className="svg-icon-warning"
                        />
                    );
                }
            },
            filterParams: {
                cellRenderer: (params: { value: any }) => {
                    const value = params.value;
                    if (value === "0") {
                        return (
                            <SVG
                                src={toAbsoluteUrl("/media/icons/duotune/general/gen034.svg")}
                                className="svg-icon-danger"
                            />
                        );
                    }
                    if (value === "1") {
                        return (
                            <SVG
                                src={toAbsoluteUrl("/media/icons/duotune/general/gen037.svg")}
                                className="svg-icon-valid"
                            />
                        );
                    }
                    if (value === "2") {
                        return (
                            <SVG
                                src={toAbsoluteUrl("/media/icons/duotune/general/gen046.svg")}
                                className="svg-icon-warning"
                            />
                        );
                    }
                    return value;
                },
            },
        },
    ];
}
